import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/`;
// const SERVER_URL = "http://localhost:3000/";



const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          لایتنر
        </Typography>
        <Typography sx={{ p: 1 }}>
          سیستم جعبه لایتنر توسط سباستین لایتنر ساخته شده‌است، که آن را در سال ۱۹۷۳ در کتاب خود تحت عنوان چگونه یاد بگیریم معرفی کرد. این روش بر اساس اثر تکرار فاصله‌ای استوار است، که طبق آن، محتوایی که طی مدت‌زمان طولانی‌تری آموخته می‌شود، در قیاس با محتوایی که در مدت‌زمان کوتاهی به شدت تکرار می‌شود، بهتر در حافظه حفظ می‌شود.
        </Typography>
        <Typography sx={{ p: 1 }}>
          با ویژگی دوزیرنویس همزمان ، دیکشنری پاپ آپ و ذخیره لغت ، کاربر تا حد زیادی مسیر یادگیری زبان با فیلم را طی کرده است اما لغتی که توسط کاربر ترجمه آن مشاهده و ذخیره شده ، برای یادگیری کامل آن نیاز به مرور لغت می باشد. جعبه لایتنر ابزاری است که برای اینکار طراحی شده است.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "60%" }} src={`${SERVER_URL}img/slider/slide7-img1.png`} />
        </Typography>

      </DemoPaper>
    </>
  )
}


export default Slide1Content;
